import axios, { Method } from 'axios';

class StarkBackend {
    private static getConfig(method: Method, endpoint: string, payload: any) {
        const url = window.__triageStore.serverBaseUrl + endpoint;
        const headers = {
            Authorization: `Bearer ${window.__triageStore.accessToken}`,
            'Content-Type': 'application/json'
        };
        if (method.toLowerCase() !== 'get') {
            return { url, method, headers, data: payload };
        }
        return { url, method, headers };
    }

    private static async SendAPIRequest(
        method: Method,
        endpoint: string,
        payload: any
    ) {
        const config = StarkBackend.getConfig(method, endpoint, payload);

        try {
            const response = await axios.request(config);

            if (response.status === 200) {
                return response.data;
            }
            throw new Error(`Failed on ${endpoint}! ${response}`);
        } catch (error: any) {
            console.error(`Error in SendAPIRequest: ${error.message}`);
            window.sentry.log(error);
            throw error; // Re-throw the error to let the caller handle it if needed.
        }
    }

    public static async getScopSettings() {
        return StarkBackend.SendAPIRequest(
            'get',
            '/ScopSettings/get_settings',
            null
        );
    }

    public static async getUserData(username: string) {
        return StarkBackend.SendAPIRequest(
            'get',
            '/user_data?username=' + username,
            null
        );
    }

    public static async updateUserData(
        username: string,
        data: Record<string, any>
    ) {
        return StarkBackend.SendAPIRequest('put', '/user_data', {
            username,
            data
        });
    }

    public static async verifyScopModels(models: string[]) {
        return StarkBackend.SendAPIRequest(
            'post',
            '/Copilot/verify_scop_model',
            { models }
        );
    }
}

export default StarkBackend;
